import registry from './routes.json'

export const SITE_URL = 'https://tools.splendapp.com'
export const DEFAULT_IMAGE = `${SITE_URL}/favicon-32x32.png`

export const routeSeo = registry.reduce((lookup, route) => {
  lookup[route.name] = route
  return lookup
}, {})

export function absoluteUrl(path) {
  const normalizedPath = path === '/' ? '/' : `/${path.replace(/^\/+/, '')}`
  return `${SITE_URL}${normalizedPath}`
}
